import GenericAjaxService from './GenericAjaxService';
import {publicAPI} from './api';

export default class UtilService extends GenericAjaxService {

  static getRegion() {
    return super.getAPI(publicAPI, `region`);
  }

  static getCountries(){
    return super.getAPI(publicAPI, `countries`);
  }

  static getLanguages(){
    return super.getAPI(publicAPI, `languages`);
  }
}